<template>
    <div class="houseDeposit">
      <bv-top></bv-top>

        <div style="text-align: center ;padding: 10px 10px 10px 10px">
          <van-image :src="watchImgUrl" style="width: 30vw;"/>
          <div style="text-align: center;padding: 10px 10px 10px 10px">
            <span style="font-family:'微软雅黑 Bold','微软雅黑 Regular','微软雅黑', sans-serif;font-weight:700;color:#666666;width: 40vw;">签署失败</span>
          </div>
          <div style="padding: 0px 0px 10px 0px"><span style="font-family:'微软雅黑', sans-serif;font-weight:400;color:#999999;padding-right: 20px ">您可通过短信链接或复制下方签署链接通过浏览器打开进行签署，签署完成后请点击下方签署完成按钮继续交存业务</span></div>
          <div style="padding: 0px 0px 10px 0px"><van-row type="flex" justify="center">
            <van-col span="1"></van-col>
            <van-col span="17">
              <van-field
                  name="ownerName"
                  v-model.trim="eSignRespose.signUrl"
                  clearable
              />
            </van-col>
            <van-col span="3">
              <van-button type="primary" size="large" @click="copySn(eSignRespose.signUrl)">复制</van-button>
            </van-col>
            <van-col span="1"></van-col>
          </van-row></div>
          <div style="padding: 0px 0px 10px 0px"><van-row type="flex" justify="center">
            <van-col span="4"></van-col>
            <van-col span="14">
              <van-button type="primary" size="large" @click="signContinue()">签署完成</van-button>
            </van-col>
            <van-col span="4"></van-col>
          </van-row></div>
          <div style="padding: 0px 0px 10px 0px"><van-row type="flex" justify="center">
            <van-col span="4"></van-col>
            <van-col span="14">
              <van-button type="primary" size="large" @click="reback()">取消</van-button>
            </van-col>
            <van-col span="4"></van-col>
          </van-row></div>
      </div>
    </div>
</template>

<script>
    import Top from '@/views/components/Top'
    import {Dialog} from "vant";
    import {findSignStatus} from "@/api/maintainFund/maintainFund";
    export default {
        name: "signFail",
        data() {
            return {
              depositApply:{},
              regionName: '',
              regionSearchName:'',
              regionNo: '',
              onLineDeposit: '',
              watchImgUrl: require("@/assets/signFail.png"),
              depAgreeId:'',
              depAgreeInfo:{},
              eSignRespose:{}
            }
        },
      created() {
          // let depositApply = this.$route.query.depositApply;
          // this.depositApply = depositApply
          // this.eSignRespose = depositApply.eSignRespose

          this.eSignRespose.depAgreeId = sessionStorage.getItem('depAgreeId');
          this.eSignRespose.signUrl=sessionStorage.getItem('signUrl');
          console.log(this.eSignRespose.signUrl)

        },

        components: {
            BvTop: Top,
        },
        methods: {
          copySn(url){
            // 创建输入框元素
            const cInput = document.createElement('input')
            // 将需要复制的值赋值给输入框的value值
            cInput.value = url
            // 页面底部添加输入框
            document.body.appendChild(cInput)
            // 选中输入框
            cInput.select()
            // 执行浏览器复制命令
            document.execCommand('copy')

            this.$toast.clear();
            Dialog.confirm({
              title: '提示',
              message: '复制成功',
            }).then(() => {
              document.body.removeChild(cInput)
            }).catch(()=>{
              document.body.removeChild(cInput)
            })
            // 移除输入框
          },
          signContinue(){
            findSignStatus(this.eSignRespose.depAgreeId).then(res=>{
              if (res.data.retCode === '1000') {  // 签署完成
                sessionStorage.setItem('depAgreeId', res.data.depAgreeId);
                sessionStorage.setItem('houseNo', res.data.houseNo);
                sessionStorage.setItem('ownerName', res.data.ownerName);
                sessionStorage.setItem('cardNo', res.data.cardNo);
                this.$router.push({path: '/onlineDeposit/signChild/signSuccess',query: {label: '签署成功',eSignRespose: res.data}})
              }
              if (res.data.retCode === '1001') {  // 正在签署
                this.$dialog.alert({
                  message: '点击E签宝链接，完成签署流程后继续操作'
                }).then(() => {
                });
              }
            }).catch(()=>{

            })
          },
          reback(){
            this.$router.push({path: '/onlineDeposit',query: {}})
          }
        }
    }
</script>

<style lang='scss' scoped>
    .houseDeposit {
        height: 100vh;
        background: #f2f2f2;

        .btn {
            margin-top: 5%;
            border-radius: 5px;
            background-color: #2acba2 !important;
            border: 1px solid #2acba2 !important;
        }

        .footFont {
            font-weight: normal;
            font-size: 14px;
            color: #999;
        }
    }

    .regionList {
        z-index: 100;
        position: absolute;
        width: 100%;
        margin-left: 25%;
        display: inline !important;
        list-style: none;
        overflow-y: scroll;
        line-height: 2;
        border-radius: 6px;
        background: white;

    }
</style>
